module.exports = __webpack_public_path__ + "img/0ec5fbb.svg";